module.exports = __webpack_public_path__ + "img/VP-ECONew-User.42b4c295.jpg";